// extracted by mini-css-extract-plugin
module.exports = {"overlay":"InputOverlay_overlay__3GV2s","card":"InputOverlay_card__mDW7R","closeButton":"InputOverlay_closeButton__1rwr3"};